import { FormattedText } from 'core/i18n';
import { recordEventCustomOnly } from 'utilities/uTagging';
import { CopyIbanButton } from 'components/copyIbanButton/CopyIbanButton';
import { isCountryPortugal } from 'utilities/multiLanguageHelper';
import { sendTextToClipBoard } from 'utilities/clipBoardHelper';
import React from 'react';

export const TransferDataContent = ({ iban, userName, userLastName, userSecondLastName, renderWarningMessage }) => {
    const handleCopyIban = () => {
        recordEventCustomOnly({
            categoriaEvento: 'onboarding/identidad/',
            accionEvento: 'copiar iban',
        });
        sendTextToClipBoard(iban);
    };
    const fullUserName = `${userName} ${userLastName} ${userSecondLastName || ''}`;

    return (
        <div className="transfer-content__data-container">
            <div className="title">
                <p className="text-heading">
                    <FormattedText value="identification-transferFromOtherAccountData" />
                </p>
            </div>
            <div className="transfer-data">
                <div className="iban-text">
                    <p className="text-regular">
                        <FormattedText value="identification-receiverAccount" />
                    </p>
                    <span className="text-bold">{iban}</span>
                    <CopyIbanButton handleCopyIban={handleCopyIban} />
                </div>
                <div className="paragraph">
                    <p className="text-regular">
                        <FormattedText value="identification-receiverName" />
                    </p>
                    <span className="text-bold">{fullUserName}</span>
                </div>

                <div className="paragraph">
                    <p className="text-regular">
                        <FormattedText value="identification-subject" />
                    </p>
                    <span className="text-bold">
                        <FormattedText value="identification-identification" />
                    </span>
                </div>

                <div className="paragraph">
                    <p className="text-regular">
                        {isCountryPortugal() ? (
                            <FormattedText value="identification-transferType" />
                        ) : (
                            <FormattedText value="identification-amount" />
                        )}
                    </p>
                    <span className="text-bold">
                        {isCountryPortugal() ? (
                            <FormattedText value="identification-transferTypeStandar" />
                        ) : (
                            <FormattedText value="identification-transferAmount" />
                        )}
                    </span>
                </div>
            </div>
            <div className="explanatory">
                <p className="text-regular">
                    <FormattedText value="identification-thisMoneyGoesToYourAccount" />
                </p>
            </div>
            {renderWarningMessage()}
        </div>
    );
};
